/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// ANCHOR Payloads
import {
  IGetCourseInvitesPayload,
  IGetCourseInviteByIdPayload,
  ICreateCourseInvitePayload,
  IDeleteCourseInvitePayload,
  ICreateCourseInvitesPayload,
} from './payloads/course-invite';

// ANCHOR Results
import {
  ICourseInviteResult,
} from './results/course-invite';

export async function getCourseInvites(
  { courseId, token }: IGetCourseInvitesPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInvites } = await sdk(token).GetCourseInvites({
    courseId: Number(courseId),
  });

  return courseInvites as ICourseInviteResult[];
}

export async function getCourseInviteById(
  { courseInviteId }: IGetCourseInviteByIdPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInvite } = await sdk().GetCourseInviteById({
    id: courseInviteId,
  });

  if (!courseInvite) {
    return undefined;
  }

  return courseInvite as ICourseInviteResult;
}

export async function createCourseInvite(
  { token, courseId, ...payload }: ICreateCourseInvitePayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInvite } = await sdk(token).CreateCourseInvite({
    courseId: Number(courseId),
    ...payload,
  });

  return courseInvite;
}

export async function createCourseInvites(
  { token, payload }: ICreateCourseInvitesPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInvite } = await sdk(token).CreateCourseInvites({
    objects: payload,
  });

  return courseInvite;
}

export async function deleteInviteCourseInvite(
  { token, id }: IDeleteCourseInvitePayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInvite } = await sdk(token).DeleteCourseInviteById({
    id,
  });

  return courseInvite;
}
